<template>
  <div class="bp-form-item"
       :class="[
       {'input-group': hasIcon},
       {'has-right-slot': addonRightIcon || this.$slots.addonRight},
       {'has-error': error},
       {'input-group-focus': focused},
       {'has-label': label || $slots.label},
       {'has-success': !error && touched && hadError}]">
    <slot name="label">
      <label v-if="label" class="bp-form-label" :class="labelClasses">
        {{label}}
        <span v-if="required" class="color-red">*</span>
        <a class="btn-link se-help-icon " v-tooltip.top-center="'Learn More'" @click="showHelp" v-if="showHelpIcon">
          <i class="fa fa-info-circle"></i>
        </a>
        <span v-if="optional" class="pull-right opacity-5 font-italic ml-2">Optional</span>
      </label>
    </slot>

    <span v-if="addonLeftIcon || $slots.addonLeft" class="input-group-addon input-group-prepend">
      <slot name="addonLeft">
        <i :class="addonLeftIcon"></i>
      </slot>
    </span>
    <slot>
      <input
        :value="value"
        v-on="listeners"
        v-bind="$attrs"
        class="bp-form-input bp-u-shadow-04"
        :class="[{valid: value && !error}, inputClasses]"
        aria-describedby="addon-right addon-left">
    </slot>
    <span v-if="addonRightIcon || $slots.addonRight" class="input-group-addon input-group-append">
      <slot name="addonRight">
        <i :class="addonRightIcon"></i>
      </slot>
    </span>

    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div class="text-danger invalid-feedback display-b"  :class="{'mt-2': hasIcon}" v-if="error">
        {{ error }}
      </div>
    </slot>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    name: 'fg-input',
    props: {
      required: Boolean,
      optional: Boolean,
      label: String,
      error: String,
      labelClasses: String,
      inputClasses: String,
      value: [String, Number],
      addonRightIcon: String,
      addonLeftIcon: String,
      showHelpIcon: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        touched: false,
        focused: false,
        hadError: false
      }
    },
    computed: {
      listeners () {
        return {
          ...this.$listeners,
          input: this.updateValue,
          focus: this.onFocus,
          blur: this.onBlur
        }
      },
      hasIcon () {
        const {addonRight, addonLeft} = this.$slots
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      }
    },
    methods: {
      updateValue (evt) {
        let value = evt.target.value
        if (!this.touched && value) {
          this.touched = true
        }
        this.$emit('input', value)
      },
      onFocus (value) {
        this.focused = true
        this.$emit('focus', value)
      },
      onBlur (value) {
        this.focused = false
        this.$emit('blur', value)
      },
      showHelp() {
        this.$emit('show-help')
      },
    },
    watch: {
      error (value) {
        if (value) {
          this.hadError = true
        }
      }
    }
  }
</script>
<style>
  .input-group.has-right-slot input{
    border-right: 0;
  }
  .color-red {
    color: red;
  }
  .display-b {
    display: block;
  }

</style>
